export const measureMaxTextWidthValue = 12;
export const availableStatusesReduceValue = 50;
export const leftAlignValue = 40;
export const legendCircleRadiusValue = 6;
export const legendTextXAttrValue = 12;
export const legendTextYAttrValue = 4;
export const sharpeRatioDealMaxValue = 99999.99;
export const lblXPosValue = 8;
export const lblYPosValue = 5;
export const sqrtOfValue = 2;
export const xPosLabelWidthValue = 9;
export const yPosLabelWidthValue = 17;
export const twentyFiveHundredthsValue = 0.25;
export const selectedDealOpacityValue = 0.4;
export const windowHeightOffsetValue = 256;
export const yAxisTranslateXValue = -50;
export const yAxisTranslateYValue = 35;
export const divideByTwoValue = 2;
export const divideByFourValue = 4;
export const multiplyByTwoValue = 2;
export const semiBoldFontWeight = 600;
export const boldFontWeight = 700;
export const oneEmFontSize = 16;
export const yAxisTickPaddingValue = 6;
export const yAxisTickAgrsValue = 7;
export const xAxisTickPaddingValue = 6;
export const xAxisTickAgrsValue = 7;
export const svgXAttrValue = 200;
export const captionTextYAttrValue = 8;
export const svgBarHeightAttrValue = 2;
export const tooltipTranslateXValue = 32;
export const tooltipTranslateYValue = 8;
export const tooltipRXAttrValue = 4;
export const tooltipRYAttrValue = 4;
export const tooltipDarkenValue = 0.3;
export const tooltipTransparentizeValue = 0.2;
export const tooltipHeightValue = 8;
export const tooltipTriangleSizeValue = 64;
export const tooltipPointerXValue = 190;
export const tooltipPointerYValue = 260;
export const addBtnDarkenValue = 0.1;
export const tooltipInnerHalfOffsetValue = 24;
export const textBaseYValue = 60;
export const dividerHeightValue = 164;
export const addBtnWidthAttrValue = 227;
export const addBtnHeightAttrValue = 37;
export const goToDealBtnYValue = 80;
export const goToDealBtnYParetoValue = 180;
export const goToDealBtnTextXValue = 100;
export const goToDealBtnTextYValue = 104;
export const goToDealBtnTextYParetoValue = 204;
export const removeFromChartBtnYValue = 126;
export const removeFromChartBtnYParetoValue = 226;
export const removeFromChartBtnTextXValue = 60;
export const removeFromChartBtnTextYValue = 150;
export const removeFromChartBtnTextYParetoValue = 250;
export const cancelBtnYValue = 172;
export const cancelBtnYParetoValue = 272;
export const cancelBtnTextXValue = 110;
export const cancelBtnTextYValue = 196;
export const cancelBtnTextYParetoValue = 296;
export const formatToTwoDecimalPlaces = 2;
export const legendMaxTextWidthCompareValue = 12;
export const legendTextXSpaceValue = 50;
export const bottomRightLegendTopPosValOne = 64;
export const bottomRightLegendTopPosValTwo = 8;
export const xAxisLabelPrefixK = 0.001;
export const xAxisLabelPrefixM = 0.001;
export const xAxisLabelPrefixMM = 0.000001;
export const tooltipRegionProductLineYValue = 2;
export const tooltipDateRangeYValue = 3;
export const tooltipNameYValue = 4;
export const colorDarkenValue = 0.2;
export const colorLightenValue = 0.2;
export const DupMarkerPrevTimerValue = 500;

export const dimensions = { width: 900, height: 600 };
export const minLeftMargin = 156;
export const maxLeftMargin = 400;
export const margin = {
  top: 32,
  right: 32,
  bottom: 64,
  left: minLeftMargin,
};

export const horizontalPadding = 0.1; // percent
export const itemHeight = 60;
export const whiskerHeight = 8;
export const whiskerThickness = 2;
export const boxHeight = 25;
export const averageCircleRadius = 4;
export const averageCircleStrokeWidth = 1;
export const tooltipWidth = 110;
export const tooltipHeight = 106;
export const tooltipPadding = 12;
export const tooltipArrowHeight = 29;
export const tooltipVerticalOffset = 4;
export const labelGapToYAxis = 16;
export const strokeWidth = 'stroke-width';
export const textAnchor = 'text-anchor';
export const fontFamily = 'font-family';
export const dataTestId = 'data-testid';

export const useEffectHeaderConst = 11;
export const pricingFormulaHeaderConst = 2;
export const volumeLabelHeaderConst = 3;
export const currencyDollarHeaderConst = 4;
export const totalRevenueHeaderConst = 5;
export const totalNetbackHeaderConst = 6;
export const totalMarginHeaderConst = 7;
export const totalMarginAtRiskHeaderConst = 13;
export const sharpeRatioHeaderConst = 14;
export const contractBatna1HeaderConst = 12;
export const ContractWOOptionsHeaderConst = 15;
export const costToServeYieldHeaderConst = 8;
export const creditTermHeaderConst = 9;
export const optionsValueHeaderConst = 10;
export const nonstandardRisksHeaderConst = 11;
